import { IsBoolean, IsOptional, IsString } from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';

export class CorrectPestControlRecordDto {
  @IsBoolean()
  pestDetected!: boolean;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  notes?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  reason?: string;
}
